import React from "react";
import { Box } from "@mui/material";
import { LoadingButton } from "./LoadingButton.styled";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { BootstrapTooltip } from "../../../../../../../../components/BootstrapTooltip";

interface Props {
  loading: boolean;

  actions: {
    importSportEquipmentListFromExcel: () => void
  };
}

export const ImportButton = (props: Props) => {
  const { loading, actions: { importSportEquipmentListFromExcel } } = props;

  return (
    <>
      <LoadingButton
        loading={loading}
        onClick={importSportEquipmentListFromExcel}
      >
        <BootstrapTooltip title={"Загрузить оборудование из Excel файла"}>
          <Box sx={{
            cursor: "pointer",
            position: "absolute",
            width: "100%",
            height: "100%",
            p: .4,
            color: "text.primary",
            fontSize: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
            {!loading &&
              <UploadFileIcon fontSize={"inherit"} />
            }
          </Box>
        </BootstrapTooltip>
      </LoadingButton>
    </>
  );
};